import { history } from 'umi';

export const openConfiguredLink = url => {
  if (url.includes('http')) {
    window.open(url, '_self');
  } else {
    history.push(url);
  }
};
